import CursorTrail from "../components/global/cursor-trail";

// "It worked" gesture for a button: a wave of squares leaving the button's shape and
// propagating outwards, then a second, tighter one right behind. Drawn by the cursor
// trail's canvas, so it only exists where the trail does (devices with a mouse).
//
//   celebrate(btn)                    standard (add to cart)
//   celebrate(btn, { level: "strong" })   bigger (e.g. Lifetime access)
//
// The squares take the button's background colour when it's solid (.c-cta--pink,
// --dark...), dark otherwise (the default glass CTA, a text link).

const SIZES = [4, 4, 8, 8, 12, 16]; // px, 16 at most
// Squares stay fully solid for this share of their life (then fade): fading from the
// start blends them into a flat grey on light backgrounds.
const HOLD = 0.6;

const DEFAULT_COLOR = "#222423"; // black_900
const MIN_ALPHA = 0.9; // below that the background is see-through: not the button's colour

function buttonColor(el) {
  const bg = getComputedStyle(el).backgroundColor;
  const m = bg.match(/rgba?\(([^)]+)\)/);
  if (!m) return DEFAULT_COLOR;
  const [r, g, b, a = 1] = m[1].split(/[\s,/]+/).filter(Boolean).map(Number);
  return a >= MIN_ALPHA ? `rgb(${r}, ${g}, ${b})` : DEFAULT_COLOR;
}

const LEVELS = {
  standard: [
    { density: 8, radius: 59, sizes: SIZES, life: 480, spread: 110, drift: 37, hold: HOLD },
    { density: 4, radius: 32, sizes: [4, 8, 8, 12, 16], life: 420, spread: 80, drift: 26, hold: HOLD, delay: 50 },
  ],
  strong: [
    { density: 14, radius: 102, sizes: SIZES, life: 620, spread: 160, drift: 54, hold: HOLD },
    { density: 8, radius: 54, sizes: [4, 8, 8, 12, 16], life: 520, spread: 110, drift: 37, hold: HOLD, delay: 60 },
  ],
};

export default function celebrate(el, { level = "standard" } = {}) {
  const trail = CursorTrail.instance;
  if (!trail || !el) return; // touch devices have no trail
  const rect = el.getBoundingClientRect(); // read now: the fragments refresh can replace the button
  if (!rect.width && !rect.height) return;
  const color = buttonColor(el);

  for (const { delay = 0, ...o } of LEVELS[level] || LEVELS.standard) {
    const opts = { ...o, color };
    if (delay) setTimeout(() => trail.burstRect(rect, opts), delay);
    else trail.burstRect(rect, opts);
  }
}
